import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import DashboardView from "containers/DashboardView";
import StartNewAward from "components/StartNewAward";
import { getAwardsSummary } from "store/actions/awardList";
import { awardListSelectors } from "store/selectors";
import LoadingIndicator from '@cayuse/shared-react.components.loading-indicator';


const AwardDashboard = ({ dashboardTilesAriaControls, searchFacets, onSearchChange, actualFacets }) => {
	const [ activeSummary, setActiveSummary ] = useState(null);
	const { search } = useSelector(awardListSelectors.content);
	const { items, isFetching } = useSelector(awardListSelectors.summary);

	useEffect(() => {
		getAwardsSummary();
	}, []);

	useEffect(() => {
		if (search?.Status) {
			setActiveSummary(search?.Status);
		} else {
			setActiveSummary(null);
		}
	}, [ search ]);

	const onTileClick = value => {
		const activeSearch = search && search.val !== value
			? { Status: value }
			: {};
		const selectedFacets = actualFacets;
		selectedFacets.status = `"${value.toLowerCase()}"`;
		onSearchChange({ facetSearch: selectedFacets, facets: searchFacets });
		const activeSummary = isNonEmptyString(activeSearch.Status) ? activeSearch.Status : null;

		setActiveSummary(activeSummary);
	};

	if (isFetching) {
		return <LoadingIndicator />;
	}

	const headerButtons = [
		<StartNewAward key="startNewAward" />
	];

	return (
		<>
			<h3 className="accessibility-text">Awards</h3>
			<p className="accessibility-text">
				Use the buttons to filter the list of awards by status.
			</p>
			<DashboardView summary={items}
				onTileClick={onTileClick}
				activeTile={activeSummary}
				headerButtons={headerButtons}
				dashboardTopic="awards"
				dashboardTilesAriaControls={dashboardTilesAriaControls}
			/>
		</>
	);
};

AwardDashboard.propTypes = {
	dashboardTilesAriaControls: PropTypes.string
};

export default AwardDashboard;
